import React from 'react';
import { Table, Badge } from 'reactstrap';

type Announcement = {
  title: string;
  startDate: string;
  endDate: string;
  description: string;
};

const CompanyAnnouncement: React.FC = () => {
  const announcements: Announcement[] = []; // Empty array = No Data

  return (
    <div>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 style={{ fontWeight: 600,display:'flex' }}>Company Announcement</h5>
      </div>

      <Table bordered responsive style={{ marginTop: 10, marginBottom: 0 }}>
        <thead style={{ backgroundColor: '#ECF7F9' }}>
          <tr style={{ color: '#83AFC2' }}>
            <th style={{ color: "#4E87BC" }}>Title</th>
            <th style={{ color: "#4E87BC" }}>Start Date</th>
            <th style={{ color: "#4E87BC" }}>End Date</th>
            <th style={{ color: "#4E87BC" }}>Description</th>
          </tr>
        </thead>
        <tbody>
          {announcements.length === 0 ? (
            <tr>
              <td colSpan={4} style={{ textAlign: 'center', padding: '40px 0' }}>
                <Badge color="success" style={{ fontSize: 14, padding: '8px 20px', borderRadius: 20 }}>
                  No Data
                </Badge>
              </td>
            </tr>
          ) : (
            announcements.map((item, index) => (
              <tr key={index}>
                <td>{item.title}</td>
                <td>{item.startDate}</td>
                <td>{item.endDate}</td>
                <td>{item.description}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default CompanyAnnouncement;
